import { Box, H1, HStack } from '@betterment/samba-react';

import { GetSupportCard } from './get-support-card/GetSupportCard';
import { PopularTopicsCard } from './popular-topics-card/PopularTopicsCard';

import { ApplicationLayout } from '../layout/ApplicationLayout';

/**
 * Help page component for the SPA.
 * Renders support contact information and popular FAQ topics.
 */
export const HelpPage = () => {
  return (
    <ApplicationLayout pageTitle="Help">
      <ApplicationLayout.Header>
        <H1 variant="title300">Help</H1>
      </ApplicationLayout.Header>
      <ApplicationLayout.Content>
        <HStack css={{ alignItems: 'flex-start', gap: 'space.400' }}>
          <Box css={{ flex: 2 }}>
            <GetSupportCard />
          </Box>
          <Box css={{ flex: 1 }}>
            <PopularTopicsCard />
          </Box>
        </HStack>
      </ApplicationLayout.Content>
      <ApplicationLayout.Footer />
    </ApplicationLayout>
  );
};
